// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__ManagePaymentMethodsPage__trashLink i{--link-icon-font-size:var(--GW-fONT-SIZE-H4)}", "",{"version":3,"sources":["webpack://./node_modules/ent-capability-billing-react/ManagePaymentMethodsPage/ManagePaymentMethodsPage.module.scss"],"names":[],"mappings":"AACI,4CACQ,4CAAA","sourcesContent":[".trashLink {\n    i {\n            --link-icon-font-size: var(--GW-fONT-SIZE-H4);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trashLink": "app__ManagePaymentMethodsPage__trashLink"
};
export default ___CSS_LOADER_EXPORT___;
